<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Store Items
        </v-card-title>
        <v-card-text>
          <!-- Category Selection -->
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                v-model="form.value_list_id"
                :items="valueLists"
                item-text="description"
                item-value="id"
                outlined
                label="Category"
                prepend-inner-icon="mdi-format-list-numbered"
              />
            </v-col>
          </v-row>

          <!-- Store Items List -->
          <template v-if="form.store_Items.length > 0">
            <v-row
              v-for="(item, pO) in form.store_Items"
              :key="`item${pO}`"
              class="mb-6"
            >
              <v-col sm="3">
                <v-text-field
                  v-model="item.name"
                  outlined
                  label="Item Name"
                  prepend-inner-icon="mdi-package-variant"
                />
              </v-col>

              <v-col sm="3">
                <v-text-field
                  v-model="item.coin"
                  outlined
                  label="Coin Value"
                  type="number"
                  prepend-inner-icon="mdi-bitcoin"
                />
              </v-col>

              <v-col sm="3">
                <v-text-field
                  v-model="item.expairy_days"
                  outlined
                  label="Expiry Days"
                  type="number"
                  prepend-inner-icon="mdi-calendar-clock"
                />
              </v-col>

              <v-col sm="2">
                <input
                  type="file"
                  :id="`file-${pO}`"
                  :ref="`file-${pO}`"
                  @change="onFileChange($event, pO)"
                />

                <v-btn
                  x-small
                  class="reset_image my-1"
                  color="red"
                  dark
                  @click="resetImage(pO)"
                >
                  Remove
                </v-btn>

                <div v-if="item.image_file" class="mt-3">
                  <label>Image Preview</label>
                  <br />
                  <img
                    :src="item.image_file"
                    style="height: 80px; width: 80px; object-fit: cover"
                  />
                </div>
              </v-col>

              <!-- Delete Button -->
              <v-col sm="1" class="d-flex align-center">
                <v-btn icon small color="error" @click="deleteItem(pO)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <!-- Add Item Button -->
          <v-row>
            <v-col>
              <v-btn color="green" dark small @click="Add_Empty_Item">
                <v-icon left>mdi-plus</v-icon> Add Item
              </v-btn>
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <!-- Save Button -->
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Store Items
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "StoreItemCreatePage",
  data() {
    return {
      form: {
        value_list_id: "",
        store_Items: [],
      },
      valueLists: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getValueLists();
  },
  methods: {
    Add_Empty_Item() {
      this.form.store_Items.push({
        name: "",
        coin: "",
        expairy_days: "",
        file: null,
        image_file: null,
      });
    },
    deleteItem(index) {
      this.form.store_Items.splice(index, 1);
    },
    async getValueLists() {
      try {
        const response = await axios.get("/masters?context=category");
        this.valueLists = response.data.category;
      } catch (e) {
        console.error(e);
      }
    },
    async save() {
      try {
        this.isLoading = true;

        // First save category + items metadata
        let response = await axios.post("/store_items", this.form);
        let savedItems = response.data.data;

        // Upload images for each item
        for (let i = 0; i < this.form.store_Items.length; i++) {
          const item = this.form.store_Items[i];
          if (item.file) {
            let formData = new FormData();
            formData.append("id", savedItems[i].id);
            formData.append("image_file", item.file);

            await axios.post("upload_storeItems_image", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
          }
        }

        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        console.error(e);
        this.isLoading = false;
      }
    },
    onFileChange(event, index) {
      const file = event.target.files[0];
      if (file) {
        this.form.store_Items[index].file = file;
        this.form.store_Items[index].image_file = URL.createObjectURL(file);
      }
    },
    resetImage(index) {
      this.form.store_Items[index].file = null;
      this.form.store_Items[index].image_file = null;
      if (this.$refs[`file-${index}`] && this.$refs[`file-${index}`][0]) {
        this.$refs[`file-${index}`][0].value = null;
      }
    },
  },
};
</script>
